/** @jsx jsx */

import { jsx } from '@emotion/core';
import { useRef, useEffect, ReactElement } from 'react';

type Props = {
  onClickOutside: () => void;
  children: ReactElement;
};

/** Hook to alert when the user has clicked outside the ref provided */
export const useOutsideClickable = (ref, onClickOutside) => {
  useEffect(() => {
    const handleClickOutside = (event: Event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClickOutside();
      }
    };
    // Bind the event listener
    document.addEventListener('click', handleClickOutside);

    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('click', handleClickOutside);
    };
  }, [ref, onClickOutside]);
};

/** Component wrapper to alert when the user has clicked outside the ref provided */
const OutsideClickable = (props: Props) => {
  const wrapperRef = useRef(null);
  useOutsideClickable(wrapperRef, props.onClickOutside);

  return <div ref={wrapperRef}>{props.children}</div>;
};

export default OutsideClickable;
